import lf from 'localforage'

export default fetch => ({
  getCountries (loading) {
    const CACHE_NAME = 'country'
    return new Promise((resolve) => {
      lf.getItem(CACHE_NAME).then(res => {
        if (res) resolve(res)
        else {
          fetch({
            url: '/api/v1/enum/GetCountryList',
            loading,
            headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
          }).then(res => {
            lf.setItem(CACHE_NAME, res)
            resolve(res)
          })
        }
      }).catch(() => resolve(null))
    })
  },
  __secretTypes: [],
  getCustomerSecretTypes (loading) {
    if (this.__secretTypes.length) {
      return Promise.resolve([...this.__secretTypes])
    } else {
      return fetch({
        url: '/api/v1/enum/GetCustomerSecretTypeList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__secretTypes = res
          return res
        }
      })
    }
  },
  getAreas (loading) {
    return fetch({
      url: '/api/v1/enum/GetAllAreasList',
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  getProvinces (loading) {
    return fetch({
      url: '/api/v1/enum/GetProvinceList',
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  getCities (ProvinceCode, loading) {
    return fetch({
      url: '/api/v1/enum/GetCityList',
      data: { ProvinceCode },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  getZones (CityCode, loading) {
    return fetch({
      url: '/api/v1/enum/GetZoneList',
      data: { CityCode },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },

  __accountRoles: [],
  getCustomerAccountRoles (loading) {
    if (this.__accountRoles.length) {
      return Promise.resolve([...this.__accountRoles])
    } else {
      return fetch({
        url: '/api/v1/enum/GetCustomerAccountRoleList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__accountRoles = res
          return res
        }
      })
    }
  },

  __BUs: [],
  getCustomerBUs (loading) {
    if (this.__BUs.length) {
      return Promise.resolve([...this.__BUs])
    } else {
      return fetch({
        url: '/api/v1/enum/GetCustomerBUList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__BUs = res
          return res
        }
      })
    }
  },

  __regions: [],
  getCustomerRegions (loading) {
    if (this.__regions.length) {
      return Promise.resolve([...this.__regions])
    } else {
      return fetch({
        url: '/api/v1/enum/GetCustomerRegionList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__regions = res
          return res
        }
      })
    }
  },

  __offices: [],
  getCustomerOffices (loading) {
    if (this.__offices.length) {
      return Promise.resolve([...this.__offices])
    } else {
      return fetch({
        url: '/api/v1/enum/GetCustomerOfficeList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__offices = res
          return res
        }
      })
    }
  },

  __reasonCategories: [],
  getReasonCategories (loading) {
    if (this.__reasonCategories.length) {
      return Promise.resolve([...this.__reasonCategories])
    } else {
      return fetch({
        url: '/api/v1/specialdelivery/GetReasonCategoryList',
        loading,
        headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
      }).then(res => {
        if (res) {
          this.__reasonCategories = res
          return res
        }
      })
    }
  }
})
